import axiosInstance from './axios';

export const fetchGet = async (url) => {
  const response = await axiosInstance.get(url);
  return response.data;
};

export const fetchGetFile = async (url) => {
  const response = await axiosInstance.get(url, {
    responseType: 'arraybuffer',
  });
  return response.data;
};

export const fetchPost = async (
  url,
  data,
  content_type = 'application/json',
) => {
  const response = await axiosInstance.post(url, data, {
    headers: { 'Content-Type': content_type },
  });
  return response.data;
};

export const fetchPut = async (
  url,
  data,
  content_type = 'application/json',
) => {
  const response = await axiosInstance.put(url, data, {
    headers: { 'Content-Type': content_type },
  });
  return response.data;
};

export const patchRequest = async (
  url,
  data,
  content_type = 'application/json',
) => {
  const response = await axiosInstance.patch(url, data, {
    headers: { 'Content-Type': content_type },
  });
  return response.data;
};

export const fetchDelete = async (url, data) => {
  const response = await axiosInstance.delete(url, { data });
  return response.data;
};

// index.js

export const uploadAttachment = async ({
  file,
  user_uuid = null,
  attachmentTypesId = 3,
}) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();

  formData.append('file', file);
  formData.append('attachmentTypesId', attachmentTypesId);
  if (user_uuid) {
    formData.append('user_uuid', user_uuid);
  }

  const response = await axiosInstance.post('/attachment/', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Don't manually set Content-Type, let the browser set it for multipart/form-data
    },
  });

  return response.data?.data;
};

export const deleteAttachment = async (uuid) => {
  const response = await axiosInstance.delete(`/attachment/${uuid}`);
  return response.data;
};

export const deleteLicenseEmployeeAttachments = async (uuids) => {
  const response = await axiosInstance.delete('/attachment/license-employee', {
    data: { uuids },
  });
  return response.data;
};
